import type { LoadState } from "@shared/models/state";
import {
  stateError,
  stateInitial,
  stateLoaded,
  stateLoading,
} from "@shared/models/state";
import { defineStore } from "pinia";
import type {
  Paginated,
  Pagination,
  PaginationQuery,
} from "../services/common";
import { ref } from "vue";
import {
  TwinChangelog,
  TwinChangelogQuery,
  getTwinChangelog,
} from "@shared/services/twinData";

export const useChangelogsStore = defineStore("changelogs", () => {
  const changelogsState = ref<
    LoadState<Array<TwinChangelog>> & {
      query?: TwinChangelogQuery;
      page?: Pagination;
      paginationQuery?: PaginationQuery;
    }
  >({
    ...stateInitial,
    query: null,
    page: null,
    paginationQuery: null,
    result: [],
  });

  async function loadChangelogs(
    page: PaginationQuery,
    query: TwinChangelogQuery,
  ) {
    changelogsState.value = { ...changelogsState.value, ...stateLoading };
    const response = await getTwinChangelog(page, query).catch((e) => {
      changelogsState.value = { ...changelogsState.value, ...stateError };
      throw e;
    });
    changelogsState.value = {
      ...stateLoaded,
      result: response.data.result,
      page: {
        total: response.data.total,
        pagesTotal: response.data.pagesTotal,
      },
      paginationQuery: page,
      query,
    };
  }

  async function reloadChangelogs() {
    // reload if loaded
    const page = changelogsState.value.paginationQuery;
    const query = changelogsState.value.query;
    if (changelogsState.value.loaded && page && query) {
      await loadChangelogs(page, query);
    }
  }

  return {
    changelogsState,
    loadChangelogs,
    reloadChangelogs,
  };
});
